import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { RootState } from '../../../store';
import { Status } from '../../../common/constants';
import { IIntegrationAdoption } from '../analytics.types';
import { getIntegrationsAnalyticsApi } from '../analyticsApi';
import { normalizeIntegrationsAnalyticsResponse } from '../analyticsUtils';

const GET_INTEGRATIONS_ANALYTICS = 'analytics/getIntegrationsAnalytics';

interface IIntegrationsAnalyticsState {
  status: string;
  error: string | null;
  integrations: IIntegrationAdoption[];
}

const initialState: IIntegrationsAnalyticsState = {
  status: Status.IDLE,
  error: null,
  integrations: [],
};

export const getIntegrationsAnalytics = createAsyncThunk(
  GET_INTEGRATIONS_ANALYTICS,
  async () => {
    const integrationsAnalyticsResponse = await getIntegrationsAnalyticsApi();
    return normalizeIntegrationsAnalyticsResponse(integrationsAnalyticsResponse);
  }
);

const integrationsAnalyticsSlice = createSlice({
  name: 'integrationsAnalytics',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getIntegrationsAnalytics.pending, (state) => {
        state.status = Status.PENDING;
        state.error = null;
      })
      .addCase(getIntegrationsAnalytics.fulfilled, (state, action) => {
        state.status = Status.SUCCESS;
        state.error = null;
        state.integrations = action.payload;
      })
      .addCase(getIntegrationsAnalytics.rejected, (state, action) => {
        state.status = Status.FAILED;
        state.error =
          action.error.message || 'Failed to fetch integrations analytics.';
      });
  },
});

export const selector = (state: RootState) => state.integrationsAnalytics;

export default integrationsAnalyticsSlice.reducer;